.Filters {
  position: absolute;
  inset: 0;
  overflow-y: scroll;
  scrollbar-width: none;
  & > * {
    margin-bottom: var(--space-md);
  }
}

.FiltersCard {
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  border-radius: var(--radius-sm);
  background: var(--bg);

  &:has(summary:focus-visible) {
    outline: 2px solid var(--focus);
    outline-offset: -2px;
  }

  summary {
    position: relative;
    display: grid;
    grid: auto / 1fr max-content;
    place-content: center;
    gap: var(--space-sm);
    font-size: 0.9375rem;
    font-weight: 600;
    padding: var(--space-sm) var(--space-md) var(--space-sm) var(--space-lg);

    svg {
      color: var(--neutral);
      place-self: center;
    }

    &:focus-visible {
      outline: none;
    }
  }

  &::details-content {
    opacity: 0.5;
    transition: opacity 250ms;
  }

  &[open]::details-content {
    opacity: 1;
    transform: none;
  }
}

.FiltersCardContent {
  display: grid;
  gap: var(--space-xs);
  padding: 0 var(--space-md) var(--space-md);

  &:has([data-slot="error"]) {
    padding-left: var(--space-lg);
  }
}

.FiltersFieldRow {
  display: grid;
  grid: auto / 1fr max-content;
  align-items: center;
  gap: var(--space-sm);
  cursor: pointer;
  border-radius: calc(var(--radius-xs) + 4px);
  border: 1px solid var(--neutral-1);
  padding: var(--space-sm) var(--space-xs) var(--space-sm) var(--space-sm);
  background: var(--white);
  text-decoration: none;
  transition: border-color 250ms;

  &:hover {
    border-color: var(--neutral);
  }

  & > span {
    font-size: 0.875rem;
    place-self: center start;
  }

  & > button,
  & > a {
    padding: 0;
    font-size: 0.8125rem;
    border-radius: 2px;
    height: fit-content;
  }

  &:has([data-slot="control"]) {
    padding: var(--space-xs) var(--space-xs) var(--space-xs) var(--space-sm);
  }
}
